import { assets } from "../../assets";
import { BrandImage } from "../BrandImage/BrandImage";
import { useTheme } from "../../theme";

export function Brand({ product = "suite", onHome, compact }: { product?: string; onHome?: () => void; compact?: boolean }): React.JSX.Element {
  const { theme } = useTheme();
  return (
    <a
      className={`nb-brand${compact ? " is-compact" : ""}`}
      href="/"
      aria-label="Nabble Suite, go to home"
      onClick={(e) => {
        if (!onHome || e.metaKey || e.ctrlKey) return;
        e.preventDefault();
        onHome();
      }}
    >
      <BrandImage src={theme === "dark" ? assets.iconDark : assets.iconLight} />
      <span className="nb-brand-text">
        <span className="nb-brand-word">
          Nabble<b>_</b>
        </span>
        <small>{product}</small>
      </span>
    </a>
  );
}
